import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Menu, Dropdown, Label } from "semantic-ui-react";
import _ from "lodash";
import { encodeUrl } from "../../utils/urlHelper";
import settings from "../../settings";

const SEARCH_PREFIX = "/search";

class DefaultMenu extends Component {
  componentDidMount = () => {};

  render() {
    const { uiData } = this.props;
    const topMenus = [];
    let menuLength = 0;
    const pathName =
      this.props.history &&
      (this.props.history.location.pathname.indexOf(SEARCH_PREFIX) !== -1
        ? this.props.history.location.pathname.substring(SEARCH_PREFIX.length)
        : this.props.history.location.pathname);
    const pathTokens = pathName && pathName.split("/");
    if (
      uiData !== null &&
      uiData !== undefined &&
      uiData.Menus !== undefined &&
      uiData.Menus !== undefined
    ) {
      menuLength = uiData.Menus.TopMenuVsSubMenuItems.length;
      _.map(uiData.Menus.TopMenuItems, (tm, index) => {
        const item = uiData.Menus.TopMenuVsSubMenuItems[tm];
        const mainMenu = _.find(
          uiData.Menus.MenuItems,
          (a) => a.MenuId === parseInt(tm, 10)
        );
        const subMenus = [];
        _.map(item, (val) => {
          const subMenu = _.find(
            uiData.Menus.MenuItems,
            (a) => a.MenuId === val
          );
          const leftMenus =
            uiData.Menus.SubMenuVsLeftMenuItems[`${subMenu.MenuId}`];
          let firstLeftMenu;
          if (leftMenus !== undefined) {
            firstLeftMenu = _.find(
              uiData.Menus.MenuItems,
              (a) => a.MenuId === parseInt(leftMenus[0], 10)
            );
            _.forEach(leftMenus, (lmId) => {
              const lm = _.find(
                uiData.Menus.MenuItems,
                (a) => a.MenuId === lmId
              );
              const report = _.find(
                uiData.Reports,
                (a) => a.ReportID === lm.ReportId
              );
              if (report && report.DefaultForMenu) {
                firstLeftMenu = lm;
              }
            });
          }
          if(settings.skipMainMenu.includes(mainMenu.MenuId)) {
            // const isNewMenu = settings.highlightAddNewBadgeMenus.includes(tm);
            // topMenus.push(<Link
            //   className="padding-5"
            //   key={`menu_${mainMenu.MenuTitle}_${subMenu.MenuTitle}`}
            //   to={`/search/${encodeUrl(mainMenu.MenuTitle)}/${encodeUrl(
            //     subMenu.MenuTitle
            //   )}${
            //     firstLeftMenu !== undefined
            //       ? `/${encodeUrl(firstLeftMenu.MenuTitle)}/${
            //           firstLeftMenu.MenuId
            //         }`
            //       : ""
            //   }`}
            // >
            //   <Dropdown.Item
            //     key={`menu_item_${mainMenu.MenuTitle}_${subMenu.MenuTitle}`}
            //     text={subMenu.MenuTitle}
            //     className={
            //       pathTokens &&
            //       pathTokens.length > 2 &&
            //       decodeURIComponent(pathTokens[2]) === subMenu.MenuTitle
            //         ? `app-main-menu menu-selected ${
            //         isNewMenu ? "border-red" : ""
            //       }`
            //     : `app-main-menu ${isNewMenu ? "border-red" : ""}`
            //     }
            //   />
            // </Link>);
            const isNewMenu = settings.highlightAddNewBadgeMenus.includes(tm);

            topMenus.push(
              <Link
                className="padding-5"
                key={`menu_${mainMenu.MenuTitle}_${subMenu.MenuTitle}`}
                to={`/search/${encodeUrl(mainMenu.MenuTitle)}/${encodeUrl(
                  subMenu.MenuTitle
                )}${
                  firstLeftMenu !== undefined
                    ? `/${encodeUrl(firstLeftMenu.MenuTitle)}/${firstLeftMenu.MenuId}`
                    : ""
                }`}
              >
                <Dropdown.Item
                  key={`menu_item_${mainMenu.MenuTitle}_${subMenu.MenuTitle}`}
                  text={
                    <span>
                      {subMenu.MenuTitle}
                      {isNewMenu && (
                        <Label
                          size="tiny"
                          basic
                          className="new-menu-label"
                        >
                          New!
                        </Label>
                      )}
                    </span>
                  }
                  className={
                    pathTokens &&
                    pathTokens.length > 2 &&
                    decodeURIComponent(pathTokens[2]) === subMenu.MenuTitle
                      ? `app-main-menu menu-selected ${
                          isNewMenu ? "border-red" : ""
                        }`
                      : `app-main-menu ${isNewMenu ? "border-red" : ""}`
                  }
                />
              </Link>
            );
          } else {
            subMenus.push(<Link
              key={`menu_${mainMenu.MenuTitle}_${subMenu.MenuTitle}`}
              to={`/search/${encodeUrl(mainMenu.MenuTitle)}/${encodeUrl(
                subMenu.MenuTitle
              )}${
                firstLeftMenu !== undefined
                  ? `/${encodeUrl(firstLeftMenu.MenuTitle)}/${
                      firstLeftMenu.MenuId
                    }`
                  : ""
              }`}
            >
              <Dropdown.Item
                key={`menu_item_${mainMenu.MenuTitle}_${subMenu.MenuTitle}`}
                text={subMenu.MenuTitle}
                className={
                  pathTokens &&
                  pathTokens.length > 2 &&
                  decodeURIComponent(pathTokens[2]) === subMenu.MenuTitle
                    ? "sub-menu-selected"
                    : ""
                }
              />
            </Link>);
          }
        });
        if(settings.skipMainMenu.includes(mainMenu.MenuId)) {
          return;
        }
        const isNewMenu = settings.highlightAddNewBadgeMenus.includes(tm);
        // const redBorder = settings.highlightAddNewBadgeMenus.includes(tm)
        //   ? "border-red" : "";

        topMenus.push(
          <Dropdown
            key={`top_menu_${index}`}
            item
            text={
              <span>
                {mainMenu.MenuTitle}
                {isNewMenu && (
                  <Label
                    size="tiny"
                    basic
                    className="new-menu-label"
                  >
                    New!
                  </Label>
                )}
              </span>
            }
            className={
              pathTokens &&
              pathTokens.length > 1 &&
              decodeURIComponent(pathTokens[1]) === mainMenu.MenuTitle
                ? `app-main-menu menu-selected ${
                    isNewMenu ? "border-red" : ""
                  }`
                : `app-main-menu ${isNewMenu ? "border-red" : ""}`
            }
          >
            <Dropdown.Menu>{subMenus}</Dropdown.Menu>
          </Dropdown>
        );
      });
    }
    const mySearchSubmenu = [];
    const mainMenu = settings.myAccountMenuItem;
    _.forEach(settings.myAccountMenuItem.subMenuItems, (subMenu) => {
      mySearchSubmenu.push(
        <Link
          key={`menu_${mainMenu.MenuTitle}_${subMenu.MenuTitle}`}
          to={`/${encodeUrl(mainMenu.MenuTitle)}/${encodeUrl(
            subMenu.MenuTitle
          )}`}
        >
          <Dropdown.Item
            key={`menu_item_${mainMenu.MenuTitle}_${subMenu.MenuTitle}`}
            text={subMenu.MenuTitle}
            className={
              pathTokens &&
              pathTokens.length > 2 &&
              decodeURIComponent(pathTokens[2]) === subMenu.MenuTitle
                ? "sub-menu-selected"
                : ""
            }
          />
        </Link>
      );
    });

    if (this.props.userAccount.acctMasterUser === "1") {
      const myCharges = "My Charges";

      mySearchSubmenu.push(
        <Link
          key={`menu_${mainMenu.MenuTitle}_${myCharges}`}
          to={`/${encodeUrl(mainMenu.MenuTitle)}/${encodeUrl(myCharges)}`}
        >
          <Dropdown.Item
            key={`menu_item_${mainMenu.MenuTitle}_${myCharges}`}
            text={myCharges}
            className={
              pathTokens &&
              pathTokens.length > 2 &&
              decodeURIComponent(pathTokens[2]) === myCharges
                ? "sub-menu-selected"
                : ""
            }
          />
        </Link>
      );
    }
    const myprofile = "My Profile";

    mySearchSubmenu.push(
      <Link
        key={`menu_${mainMenu.MenuTitle}_${myprofile}`}
        to={`/${encodeUrl(mainMenu.MenuTitle)}/${encodeUrl(myprofile)}`}
      >
        <Dropdown.Item
          key={`menu_item_${mainMenu.MenuTitle}_${myprofile}`}
          text={myprofile}
          className={
            pathTokens &&
            pathTokens.length > 2 &&
            decodeURIComponent(pathTokens[2]) === myprofile
              ? "sub-menu-selected"
              : ""
          }
        />
      </Link>
    );

    topMenus.push(
      <Dropdown
        key={`top_menu_${menuLength}`}
        item
        text={settings.myAccountMenuItem.MenuTitle}
        position="right"
        className={
          pathTokens &&
          pathTokens.length > 1 &&
          decodeURIComponent(pathTokens[1]) ===
            settings.myAccountMenuItem.MenuTitle
            ? `app-main-menu last-menu-item menu-selected`
            : `app-main-menu last-menu-item`
        }
      >
        <Dropdown.Menu>{mySearchSubmenu}</Dropdown.Menu>
      </Dropdown>
    );
    return (
      <div className={`no-print`}>
        <Menu fluid borderless stackable>
          {topMenus}
        </Menu>
      </div>
    );
  }
}

export default DefaultMenu;



// WEBPACK FOOTER //
// ./src/components/pages/DefaultMenu.js